import { Component, ViewChild,Input,Output, EventEmitter, effect, inject, ViewChildren, QueryList, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { BudgetGenerateService } from '@services/budget-generate.service';
import { NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { UserService } from '@services/core/user.service';
import { Entity } from '@model/entity.model';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { FilterModel } from './filter.model';


@Component({
  selector: 'app-departament',
  templateUrl: 'departament.component.html',
  styleUrl: 'departament.component.css',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    CommonModule
  ],
  providers: [NgbModal],
})
export class DepartamentComponent {
  @ViewChildren('input') inputs!: QueryList<ElementRef>;
  @ViewChild('modal_account', { static: true }) modalAccount: any;
  @ViewChild('nameInput') nameInput: ElementRef;
  @ViewChild('ngSelect', { static: false }) ngSelectAssinet: NgSelectComponent;
  private modalRef: NgbModalRef;
  public filter: FilterModel = new FilterModel();
  private userService = inject(UserService);
  public budgetGenerateService = inject(BudgetGenerateService);
  private _identityService = inject(UserService);
  private entitySelected: Entity;
  public departamentPlanVersion;
  public departamentPlanVersionTemp;
  public dataSource;
  public formDepartamentPlan: FormGroup;
  public departament;
  public titleModal;
  
  private budgetVersionSelected;
  public budgetFund;
  public fundSelect;
  selectDepartament;
  public groupedDepartments: any[] = [];
  public selected;
  public departamentTemp;

  constructor(private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
  ) {

    effect(() => {
      this.entitySelected = this._identityService.sharingEntity();
      if (this.entitySelected && Object.keys(this.entitySelected).length > 0) {     
        
      }
     

    })
    effect(()=> {
      this.budgetVersionSelected = this.userService.sharingBudgetVersion()
      const budgetFundData = this.userService.sharingBudgetFund();
       if (this.budgetVersionSelected?.year) {  
        this.budgetFund = budgetFundData;
        this.fundSelect = this.budgetFund[0]?.fundCode;    
        this.filter.year = this.budgetVersionSelected.year;
        this.filter.version = this.budgetVersionSelected.version;
        this.formDepartamentPlan.get('year').patchValue(this.filter.year);
        this.formDepartamentPlan.get('version').patchValue(this.filter.version);
        this.formDepartamentPlan.get('entityCode').patchValue(this.entitySelected?.code);
        this.getDepartamentRef();
        this.getAasinetDepartament();

      }
    })

  }

// En tu componente.ts





  


  /**crear formulario reactivo diverso*/
  createFormAccount() {
    this.formDepartamentPlan = this.formBuilder.group({
      id:[undefined],
      departamentCode: [undefined, [Validators.minLength(1)]],
      displayName: ['', [Validators.required, Validators.minLength(3)]],
      entityCode: ['', [Validators.required, Validators.minLength(1)]],
      fundCode:['', [Validators.required]],
      year: ['', [Validators.required]],
      version: ['', [Validators.required]],
    });
  }


  setDepartament(id) {
    return this.dataSource.find(acc => acc.id == id);
  }


    /**Actualiza el items travel*/
    updateDepartamentCheck(data, field, newValue) {
        this.budgetGenerateService.updateDepartamentBudgetConfig({ id: data.id, [field]: newValue }).subscribe(res => {
         })
    }



  /**Elimina un items de travel*/
  deleteDepartament(params) {
    Swal.fire({
      icon: 'warning',
      title: 'Alerta ',
      text: '¿Desea eliminar el departamento ' + params.departamentCode + ' ' + params.displayName + '? Se eliminaran todos los registros de este departamento',
      toast: false,
      position: 'center',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      timer: null,
      timerProgressBar: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.budgetGenerateService.deleteDepartamentRef({ id: params.id }).subscribe(res => {
          this.notification('Departamento ' + params.departamentCode + ' ' + params.displayName + ' eliminado ');
          this.getDepartamentRef();
          this.getAasinetDepartament();
        })

      }
    })



  }

  ngOnInit() {
    /**aqui podemos recibir los valores desde la tabla budget_version */
    this.createFormAccount();
  }




  /**trae el plan de los departamentos */
  getDepartamentRef() {
    delete this.filter.type_id;
    this.budgetGenerateService.getDepartamentRef(this.filter).subscribe(res => {
      this.departamentPlanVersion = res;
      this.departamentPlanVersionTemp =JSON.parse(JSON.stringify(this.departamentPlanVersion));
      
      this.changeFund(this.fundSelect);
      

    })
  }



  groupByParent(data) {
    const map = new Map<string, any[]>();
  
    for (const item of data) {
      const key = item.parentName;
      if (!map.has(key)) {
        map.set(key, []);
      }
      map.get(key)?.push(item);
    }
  
    this.groupedDepartments = Array.from(map.entries()).map(([parentName, departments]) => ({
      parentName,
      parentCode: departments[0].parentCode,
      departments,
    }));
  }

  /**trae las cuentas */
  getAasinetDepartament() {
    this.budgetGenerateService.getAasinetDepartament().subscribe(res => {
      this.departamentTemp=JSON.parse(JSON.stringify(res?.filter(d=>d.acceptEntries&&d.isActive)));
      this.departament = this.mapSelect(this.departamentTemp)
    })
  }


  addDepartament(data){
    this.formDepartamentPlan.patchValue({
      id: null,
      entityCode: this.entitySelected?.code,
      year: this.filter.year,
      version: this.filter.version,
      displayName: data.name,
      fundCode:this.fundSelect,
      departamentCode: data.departamentCode,
    });
   
   const departament=this.departament.find(d=>d.departamentCode==data.departamentCode);
   departament.isActive=false;
   departament.disabled=true;
   this.departament = [...this.departament];
    this.formDepartamentPlan.get('id').disable();
     this.budgetGenerateService.saveDepartamentRef(this.formDepartamentPlan.value).subscribe(res => {      
      this.resetForm();
      this.notification('Departamento guardado exitosamente');
    })
    
  }

  blurNgSelect(){
    this.selected=[];
    this.getDepartamentRef();
    this.getAasinetDepartament();
  }

  changeFund(fundCode) {
    this.fundSelect=fundCode;
    if(this.departamentPlanVersionTemp){    
    this.departamentPlanVersion = this.departamentPlanVersionTemp.filter(d => 
      d.fundCode==this.fundSelect
    );
    this.dataSource = this.departamentPlanVersion;
    this.selectDepartament = this.departamentPlanVersion.map(d => d.departamentCode);
    this.groupByParent(this.departamentPlanVersion);
  }
}




  /*abre los modales */
  open(content, size?) {
    this.modalRef = this.modalService.open(content, size);
  }

  /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  /**abre el modal de agregar cuenta */
  openModalAccount() {
    this.open(this.modalAccount)
  }


  /**busca los las cuentas q no existen  */
  findDepartamentPlan(code): boolean {
    let r = false;
    try {
      r = !this.departamentPlanVersion.some((a) => a.departamentCode== code);
    }
    catch {
    }
    return r
  }


    /**abre el modal de agregar departamento */
    openModalDepartament() {
      this.titleModal='Agregar Departamento';
      this.formDepartamentPlan.reset();
      this.formDepartamentPlan.get('id').patchValue(undefined);
      this.formDepartamentPlan.get('departamentCode').enable();    
      this.formDepartamentPlan.get('entityCode').patchValue(this.entitySelected?.code);
      this.formDepartamentPlan.get('allowsTithe').patchValue(true);
      this.formDepartamentPlan.get('allowsNonTithe').patchValue(false);
      this.formDepartamentPlan.get('year').patchValue(this.filter.year);
      this.formDepartamentPlan.get('version').patchValue(this.filter.version);
      this.open(this.modalAccount)
     
    }

    


  /**busca los las cuentas q existen  */
  findAcount(code): boolean {
    return this.dataSource.some((a) => a.departament_code == code);
  }

  setFormDepartament(account){
    this.titleModal='Editar Departamento';
    this.formDepartamentPlan.patchValue(account);
    this.formDepartamentPlan.get('departamentCode').disable();
    this.formDepartamentPlan.get('departamentCode')?.markAsPristine();
    this.formDepartamentPlan.get('displayName')?.markAsPristine();
    this.formDepartamentPlan.get('displayName')?.markAsUntouched();
    this.open(this.modalAccount)
  }

  /*mapea los datos del ng-select deshabilita los registros q ya entan registrado */
  mapSelect(data) {
    data = data?.filter(d => !this.selectDepartament?.includes(d.code));    
    let newData = data.map((d) => {
      const name = d.name
      const isActive = true;
      return {
        departamentCode: d.code,
        nameCode: d.code + ' - ' + name,
        parentName: d.parentName,
        name: name,
        disabled: !isActive,
        isActive: isActive
      }
    });
    return newData
  }

  disableDepartament(code: string) {
    const item = this.departament.find(d => d.departamentCode === code);
    if (item) {
      item.isActive = false;
    }
  }
  

  
    /**al cerrar el ngselect le pasa el foco y el valor al input de displayName */
    closeNgSelect(value) {
      this.formDepartamentPlan.get('displayName').patchValue(value.selectedItems[0]?.value?.name);
      this.nameInput.nativeElement?.focus();
      this.nameInput.nativeElement?.select();
    }
  


  resetForm() {
    this.formDepartamentPlan.patchValue({
      id:undefined,
      departamentCode: undefined,
      displayName: undefined,
      hint: '',
    });
    this.formDepartamentPlan.get('departamentCode')?.markAsPristine();
    this.formDepartamentPlan.get('displayName')?.markAsPristine();
    this.formDepartamentPlan.get('displayName')?.markAsUntouched();


  }




  /**al cerrar el ngselect le pasa el foco y el valor al input de displayName */
  submitNewDepartament() {
     if (this.formDepartamentPlan.valid) {
      this.budgetGenerateService.saveDepartamentRef(this.formDepartamentPlan.value).subscribe(res => {
        this.getDepartamentRef();
        this.close();
        this.resetForm();
        this.notification('Departamento guardado exitosamente');
      })
    }
  }


    /*Actualiza la cuenta*/
    submitUpdate() {
      if (this.formDepartamentPlan.valid) {
       let data=this.formDepartamentPlan.value;
       const departament=this.setDepartament(data.id);
       data.departamentCode=departament.departamentCode;
       this.budgetGenerateService.updateDepartamentRef(data).subscribe(res => {
         departament.displayName=this.formDepartamentPlan.value.displayName;
         departament.hint=this.formDepartamentPlan.value.hint;
         this.close();
         this.resetForm();
         this.notification('Departamento actualizado exitosamente');
       })
     }
   }


  notification(title) {
    const Toast = Swal.mixin({
      icon: 'success',
      title: title,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
    Toast.fire();
  }



}


